<template>
  <el-container>
    <el-header class="HomeHeader">
      <div class="HomeHeader-content">
        <div style="display: flex;">
          <el-image :src="img.ZDLogo" class="HomeHeader-logo"></el-image>
          <el-image :src="img.ZDTitle" class="HomeHeader-title"></el-image>
        </div>
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          active-text-color="#7E49FE"
          style="margin-left: 8rem"
        >
          <el-menu-item
            class="HomeHeader-item-home"
            index="a1"
            @click="menuSelect('a1')"
          >
            首页
          </el-menu-item>
          <el-submenu
            :index="sIndex + ''"
            v-for="(menu, sIndex) in menus"
            :key="sIndex"
          >
            <template slot="title">{{ menu.title }}</template>
            <el-menu-item
              @click="menuSelect(item.index)"
              :index="item.index"
              v-for="(item, index) in menu.items"
              :key="sIndex + index"
            >
              {{ item.title }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <el-button class="HomeHeader-button1" @click="onMerchantClick">
          商家后台
        </el-button>
        <el-button
          class="HomeHeader-button2"
          type="primary"
          @click="onTryOutClick"
        >
          申请试用
        </el-button>
      </div>
    </el-header>
    <el-main class="HomeMain" style="margin-top: 60px">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import ZDLogo from "@/assets/img/home/blk_logo.png";
import ZDTitle from "@/assets/img/home/blk_title.png";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      img: {
        ZDLogo,
        ZDTitle,
      },
      browserHeight: "",
      activeIndex: "a1",
      selectProduct: 1, //选中的 产品系统功能页签
      menus: [
        {
          title: "产品功能",
          items: [
            {
              title: "私域流量",
              index: "a2",
            },
            {
              title: "精准获客",
              index: "a3",
            },
          ],
        },
        {
          title: "解决方案",
          items: [
            {
              title: "珠宝门店",
              index: "a4-1",
            },
            {
              title: "电商行业",
              index: "a4-2",
            },
            {
              title: "网红主播",
              index: "a4-3",
            },
          ],
        },
        {
          title: "渠道合作",
          items: [
            {
              title: "渠道加盟",
              index: "a7",
            },
            {
              title: "珠宝检测",
              index: this.$store.state.bwzUrl,
            },
          ],
        },
        {
          title: "更多服务",
          items: [
            {
              title: "宝物志",
              index: this.$store.state.bwzUrl + "/",
            },
            {
              title: "宝来屋",
              index: this.$store.state.blwUrl + "/",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    onMerchantClick() {
      window.open(this.$store.state.blkUrl + "/home");
    },
    onTryOutClick() {
      window.open(this.$store.state.blkUrl + "/loginRegister");
    },
    menuSelect(index) {
      if (index.indexOf("://") != -1) {
        window.open(index);
        this.activeIndex = "a1";
      } else {
        let id = index.split("-");
        var anchor = this.$el.querySelector("#" + id[0]);
        document.documentElement.scrollTop = anchor.offsetTop - 60;
        if (id[1]) {
          this.selectProduct = id[1];
          this.$store.state.projectSelectState.Select = this.selectProduct - 1;
        }
      }
    },
    onScroll(e) {
      let index = 1;
      let items = [];
      while (true) {
        let item = document.getElementById("a" + index);
        if (item) {
          items.push(item);
          index = index + 1;
        } else {
          break;
        }
      }
      let scrollTop = document.documentElement.scrollTop;
      for (let i = items.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge = scrollTop >= items[i].offsetTop - 60;
        if (judge) {
          if (i == 3) {
            this.activeIndex = "a" + (i + 1) + "-" + this.selectProduct;
          } else if (i >= 4) {
            this.activeIndex = "a7";
          } else {
            this.activeIndex = "a" + (i + 1);
          }
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.HomeHeader {
  background: $back-color;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  box-shadow: 0px 4px 11px 0px rgba(122, 98, 245, 0.08);
  &-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    width: 1400px;
    margin: 0 auto;
  }
  &-logo {
    width: 41px;
    height: 42px;
  }
  &-title {
    width: 82px;
    height: 45px;
    margin-left: 5px;
  }
  &-activeTitle {
    font-size: 16px;
    color: #7e49fe;
  }
  &-defaultTitle {
    font-size: 16px;
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
      "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  }
  &-button1 {
    border-color: #7e49fe;
    margin-left: -130px !important;
  }
  &-button2 {
    color: white;
    margin-left: -130px !important;
  }
  &-item-home {
    margin: 0 20px 0 0px !important;
  }
}
.HomeMain {
  padding: 0;
  background: $back-color;
}
.el-image {
  display: block !important;
}
.el-header {
  padding: 0;
}
.el-menu-item {
  border-bottom-width: 0px !important;
  font-size: 16px;
  font-weight: 400;
  color: #211c39;
}
// .el-menu-item:hover {
//   color: #7E49FE !important;
// }
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px !important;
  height: 16px;
  font-size: 16px;
  font-weight: 800;
  color: #7e49fe;
}
.el-submenu {
  padding-left: 20px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0 !important;
}
</style>
<style>
.el-menu--popup {
  margin: 0 18px !important;
  min-width: 0px !important;
  padding: 0 20px !important;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0px !important;
  font-size: 16px;
  font-weight: 800;
  color: #7e49fe;
}
/* .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    color: #7E49FE !important;
  } */
.el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 0px !important;
  font-size: 16px;
  font-weight: 400;
  color: #211c39;
}
div {
  -webkit-font-smoothing: subpixel-antialiased;
}
</style>
